import Vue from 'vue';
import Router from 'vue-router';
import BootstrapVue from 'bootstrap-vue';
import Container from '@/views/Container';

Vue.use(Router);
Vue.use(BootstrapVue);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Container',
      component: Container,
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js